// extracted by mini-css-extract-plugin
export var resizer = "_hs-0";